import React, { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';

const EVENTS_LISTENER = {
  pbi: ['pbi:refresh'],
};

export const SocketContext = React.createContext({
  socket: null,
  socketStatus: false,
});

export const SocketSubscribe = (socket, eventName, eventHandler) => {
  console.log('Socket adding listener', eventName);
  socket && socket.on(eventName, eventHandler);
};

export const SocketEmit = (socket, eventName, msg) => {
  console.log('Socket emitting message', eventName);
  socket && socket.emit(eventName, msg);
};

export const SocketRemoveListeners = (socket, type) => {
  console.log('Socket removing listener');
  socket &&
    EVENTS_LISTENER[type] &&
    EVENTS_LISTENER[type].forEach((e) => socket.off(e));
};

const SocketProvider = ({ children }) => {
  const [socketStatus, setStatus] = useState(false);
  const socketRef = useRef(null);
  const token = window.localStorage.getItem('accessToken');
  let baseURL = process?.env?.REACT_APP_common_service_url;
  baseURL = baseURL?.endsWith('/ma') ? baseURL.slice(0, -3) : baseURL;

  useEffect(() => {
    socketRef.current = io(`${baseURL}/ma`, {
      auth: { token },
      path: process?.env?.REACT_APP_websocket_path,
      transports: ['websocket', 'polling'],
      reconnection: false,
    });
    socketRef.current.on('connect', () => {
      console.log('The refresh socket has connected:', socketRef.current.id);
      setStatus(true);
    });

    socketRef.current.on('disconnect', (reason) => {
      console.log('The refresh socket has disconnected:', reason);
      socketRef.current.removeAllListeners();
      setStatus(false);
    });

    socketRef.current.io.on('reconnect', (attempt) => {
      console.log(`Successfully refresh reconnected after ${attempt} attempts`);
      setStatus(true);
    });

    socketRef.current.io.on('reconnect_failed', () => {
      console.log('Failed to refresh reconnect socket:', socketRef.current.id);
      setStatus(false);
    });

    socketRef.current.io.on('error', (err) => {
      console.log('Socket refresh', err.toString());
      setStatus(false);
    });

    return () => {
      if (socketRef && socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, socketStatus }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
